import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { IconDelivery, IconEuro, IconPrescription } from '@redteclab/icons'
import { type FunctionComponent } from 'react'

import Notification, {
  NOTIFICATION_TYPES,
} from 'views/components/molecules/Notification'
import { FREE_ENVELOPE_LINK } from 'views/components/pages/RedeemRecipe/const'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import './RxBonusContent.scss'

interface RxBonusContentProps {
  open?: boolean
}

export const RXBonusContentHeading = () => {
  return (
    <TransWithHtml
      className="m-RxBonusContent__heading"
      text={i18n._('prescriptionBonus.modal.title')}
    />
  )
}

const RxBonusContent: FunctionComponent<RxBonusContentProps> = () => {
  const benefitsListItem = [
    {
      text: <Trans id={'prescriptionBonus.modal.benefit1'} />,
      icon: <IconEuro width={24} height={24} />,
    },
    {
      text: <Trans id={'prescriptionBonus.modal.benefit2'} />,
      icon: <IconPrescription width={24} height={24} />,
    },
    {
      text: <Trans id={'prescriptionBonus.modal.benefit3'} />,
      icon: <IconDelivery width={24} height={24} />,
    },
  ]

  return (
    <main className="m-RxBonusContent">
      <article className="m-RxBonusContent__article">
        <Trans
          id="prescriptionBonus.modal.descriptionText"
          components={{
            redeemRecipeLink: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a href={FREE_ENVELOPE_LINK} target="_blank" rel="noreferrer" />
            ),
          }}
        />
        <ul className="m-RxBonusContent__article__list">
          {benefitsListItem.map((item, index) => (
            <li
              key={`benefit-${index}`}
              className="m-RxBonusContent__article__list__item"
            >
              {item.icon}
              <p className="m-RxBonusContent__article__list__item__text">
                {item.text}
              </p>
            </li>
          ))}
        </ul>
        <TransWithHtml
          text={i18n._('prescriptionBonus.modal.privatePatient.description', {
            url: '/lp/rezeptbonus/',
          })}
        />
      </article>
      <Notification
        alignIcon={'top'}
        label={<Trans id="prescriptionBonus.modal.notice" />}
        type={NOTIFICATION_TYPES.WARNING}
      />
    </main>
  )
}

export default RxBonusContent
